import "../../style/mobile/azmoon-list/M_CurrentExams.scss";
import icon1 from "../../../assets/mobile/home/vuesax-linear-calendar.svg";
import icon2 from "../../../assets/mobile/home/vuesax-linear-profile-2user.svg";
import icon3 from "../../../assets/mobile/home/vuesax-linear-teacher.svg";
import { useSelector } from "react-redux";
import { useState } from "react";
import moment from "jalali-moment";
import { Link } from "react-router-dom";

// let data = [
//   {
//     id: 1,
//     img: img1,
//     title: "آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price: "450.200",
//     discounted_price: "405.000",
//     discount: "10%",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "discounted",
//     exam_filter: "none",
//     user_num: 100,
//   },
//   {
//     id: 2,
//     img: img3,
//     title: "آزمون زیست شناسی دهم",
//     // price:458.200,
//     price: "350.000",
//     discounted_price: "305.000",
//     discount: "10%",
//     date: "28 آبان 1400",
//     level: "کارشناسی",
//     type: "گروهی",
//     filter: "discounted",
//     exam_filter: "live",
//     user_num: 100,
//   },
//   {
//     id: 3,
//     img: img1,
//     title: "آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price: "350.200",
//     discounted_price: "305.000",
//     discount: "10%",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "discounted",
//     exam_filter: "none",
//     user_num: 100,
//   },
//   {
//     id: 4,
//     img: img3,
//     title: "آزمون روان درمانی اگزیستانسیال",
//     // price:458.200,
//     price: "458.200",
//     discounted_price: "",
//     discount: "",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "none",
//     exam_filter: "collegiate",
//     user_num: 100,
//   },
//   {
//     id: 5,
//     img: img2,
//     title: "آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price: "458.200",
//     discounted_price: "",
//     discount: "",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "none",
//     exam_filter: "collegiate",
//     user_num: 100,
//   },
//   {
//     id: 6,
//     img: img1,
//     title: "آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price: "458.200",
//     discounted_price: "",
//     discount: "",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "none",
//     exam_filter: "none",
//     user_num: 100,
//   },
//   {
//     id: 7,
//     img: img1,
//     title: "آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price: "350.000",
//     discounted_price: "",
//     discount: "",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "none",
//     exam_filter: "collegiate",
//     user_num: 100,
//   },
//   {
//     id: 8,
//     img: img2,
//     title: "آزمون آشپزی شرق آسیا",
//     // price:458.200,
//     price: "458.200",
//     discounted_price: "رایگان",
//     discount: "100%",
//     date: "28 آبان 1400",
//     level: "پایه 1 الی 12",
//     type: "گروهی",
//     filter: "free",
//     exam_filter: "none",
//     user_num: 100,
//   },
// ];

const M_CurrentExams = () => {
  const state = useSelector((state) => state.default);
  const [data] = useState(state.ExamData);

  moment.locale("en");
  return (
    <div className="M_CurrentExams">
      {data.map((item) => (
        <div className="M_CurrentExams-item" key={item.id}>
          <div className="M_CurrentExams-item-img-container">
            <img src={item.img} alt="item-img" />
            <Link to={`/dashboard/azmoon_list/enter_exam/${item.id}`} className="M_CurrentExams-item-img-container-cover"></Link>
          </div>
          <div className="M_CurrentExams-item-title">{item.name}</div>
          {/* <div className="M_CurrentExams-item-price-box">
                <div style={item.discount?{textDecoration:"line-through",color:"#A7A5A5"}:{
                  width:"100%",justifyContent:"center"
                }} className="M_CurrentExams-item-price-box-main-price">
                  {item.price}
                  <span>تومان</span>
                </div>
                {item.discount &&<div className="M_CurrentExams-item-price-box-discounted-price">
                  {item.discounted_price}
                  <span>تومان</span>
                </div>}
                {item.discount && <div className="M_CurrentExams-item-price-box-discount">
                  {item.discount}
                </div>}
              </div> */}
          <div className="M_CurrentExams-item-info">
            <div className="M_CurrentExams-item-info-date">
              <img
                src={icon1}
                alt="date-icon1"
                className="M_CurrentExams-item-info-date-icon"
              />
              <div className="M_CurrentExams-item-info-date-text">
                {moment(item.date, 'YYYY/MM/DD').format('jYYYY/jM/jD')}
              </div>
            </div>
            <div className="M_CurrentExams-item-info-level">
              <img
                src={icon2}
                alt="date-icon1"
                className="M_CurrentExams-item-info-level-icon"
              />
              <div className="M_CurrentExams-item-info-level-text">
                {item.level}
              </div>
            </div>
            <div className="M_CurrentExams-item-info-type">
              <img
                src={icon3}
                alt="date-icon1"
                className="M_CurrentExams-item-info-type-icon"
              />
              <div className="M_CurrentExams-item-info-type-text">
                {item.type===1 && "انفرادی"}
                {item.type===2 && "گروهی"}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default M_CurrentExams;
